import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { CustomerData } from "@/types/client";

const quote = (val: string | number | undefined | null): string => {
  const s = val == null ? "" : String(val);
  return `"${s.replace(/"/g, '""')}"`;
};

/**
 * Export clients to CSV with all enriched fields
 */
export const exportClientsToCSV = (clients: CustomerData[]) => {
  const headers = [
    "Prénom",
    "Nom",
    "Email",
    "Téléphone",
    "Civilité",
    "Société",
    "Adresse",
    "Ville",
    "Code postal",
    "Pays",
    "Langue",
    "Date de naissance",
    "Statut",
    "Notes",
    "Allergies (notes)",
    "Allergies (tags)",
    "Tags client",
    "Blacklisté",
    "No-show",
    "Consent marketing email",
    "Consent marketing SMS",
    "Email professionnel",
    "Tél. professionnel",
    "Consent review email",
    "Consent review SMS",
    "Nb réservations",
    "Nb personnes total",
    "Première visite",
    "Dernière visite",
  ];

  const rows = clients.map(client => [
    quote(client.firstName),
    quote(client.lastName),
    quote(client.email),
    quote(client.phone),
    quote(client.civility),
    quote(client.company),
    quote(client.address),
    quote(client.city),
    quote(client.zip),
    quote(client.country),
    quote(client.lang),
    quote(client.birthdate),
    quote(client.guestStatus),
    quote(client.notes),
    quote(client.allergiesNotes),
    quote((client.allergiesTags || []).join(', ')),
    quote((client.guestTags || []).join(', ')),
    quote(client.isBlacklisted ? "Oui" : "Non"),
    quote(client.hasNoShow ? "Oui" : "Non"),
    quote(client.marketingConsent ? "Oui" : "Non"),
    quote(client.smsConsent ? "Oui" : "Non"),
    quote(client.professionalEmail),
    quote(client.professionalPhone),
    quote(client.reviewEmailConsent ? "Oui" : "Non"),
    quote(client.reviewSmsConsent ? "Oui" : "Non"),
    quote(client.totalReservations),
    quote(client.totalPersons),
    quote(client.firstReservationDate ? format(client.firstReservationDate, "dd/MM/yyyy", { locale: fr }) : ""),
    quote(client.lastReservationDate ? format(client.lastReservationDate, "dd/MM/yyyy", { locale: fr }) : ""),
  ]);

  const csvContent = [
    headers.map(h => quote(h)).join(","),
    ...rows.map(row => row.join(","))
  ].join("\n");

  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  const filename = `clients_${format(new Date(), "yyyy-MM-dd_HH-mm")}.csv`;
  
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
